import type { MouseEvent } from "react";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import { Label } from "../../misc/Label";
import type { DrivingSchoolLabel } from "../../providers/drivingSchoolLabelsProvider";

export function LabelMobileListItem(props: {
  label: DrivingSchoolLabel;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { label, onClick } = props;
  const theme = useTheme();
  const usageCountLabel = label.usageCount === 1 ? "1 Fahrschüler" : `${label.usageCount} Fahrschüler`;

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Label label={label} hideTooltip />
        <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
          {label.description}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {usageCountLabel}
        </Typography>
      </Column>
    </ButtonBase>
  );
}
